import { API } from '@/api/API';
// flow_definition is not embedded here — the API auto-includes it when a ticket has a flow_resolution_id.
export const fetchCartEmbeds = 'identity,ticket,ticket.ticket_type,ticket.ticket_group,ticket_group.meta,ticket.event_session,ticket.event_template,event_template.venue,event_template.config,event_template.meta,scheduled_payment,seller';
export function fetchOwnCart(id) {
    return API.getUncached(`my/cart/${id}`, cartApiParams());
}
export function fetchCart(id, query) {
    return API.getUncached(`cart/${id}`, cartApiParams(query));
}
export function applyCartCodes(id, body) {
    return API.post(`my/cart/${id}/apply_code`, { body, ...cartApiParams() });
}
export function cartApiParams(query) {
    return {
        limit: 1000,
        embed: fetchCartEmbeds,
        query: {
            ...query,
            // TODO Why do we need the session_picker_tabs configuration for cart data?
            'config.key._in': 'config.image,web.session_picker_tabs',
        },
    };
}
